<template>
  <rich-button @click="commands.bold" v-bind:isActive="isActive.bold()" v-bind:icon="'bold'" />
</template>

<script>
  import BoldButton from './BoldButton.ts'
  export default BoldButton
</script>
